import { render } from "./QuanLyBaoDuong.vue?vue&type=template&id=7237b505&scoped=true"
import script from "./QuanLyBaoDuong.vue?vue&type=script&lang=js"
export * from "./QuanLyBaoDuong.vue?vue&type=script&lang=js"

import "./QuanLyBaoDuong.vue?vue&type=style&index=0&id=7237b505&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7237b505"]])

export default __exports__